import { useEffect } from 'react';
import { translate } from '@utils';
import { setNotification } from '@actions/appActions';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { MgState, SnackNotification } from '@types';

export const useNotifications = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const notification = useSelector<MgState, SnackNotification>(({ app }) => app.notification);

  useEffect(() => {
    if (notification) {
      const { textKey, additionalText, variant, duration } = notification;
      const notificationText = additionalText
        ? `${translate(textKey)} ${additionalText}`
        : translate(textKey);
      const key = enqueueSnackbar(notificationText, {
        variant,
        autoHideDuration: duration || 3000,
      });
      dispatch(setNotification(null));
      return () => {
        setTimeout(() => closeSnackbar(key), duration || 3000);
      };
    }
  }, [notification]);
};
